// extracted by mini-css-extract-plugin
export default {"aboutBody":"About_aboutBody__GmS7i"};